
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import Icon from "@/components/UI/Icon.vue";
import SearchInput from "@/components/Reusable/CustomInputs/SearchInput.vue";
import Fuse from "fuse.js";
import { DesignSetPost } from "@/types/design-library";
import AlertBox from "@/components/Reusable/CustomInputs/AlertBox.vue";

@Component({
  components: { AlertBox, SearchInput, Icon }
})
export default class DesignLibrarySidebar extends Vue {
  @Prop({
    default() {
      return [];
    }
  })
  items!: DesignSetPost[];

  searchQuery = "";

  get filteredItems() {
    const search = this.searchQuery;

    if (!search) return this.items;

    const fuse = new Fuse(this.items, {
      keys: ["name"],
      threshold: 0.2
    });

    return fuse.search(search.trim()).map(r => r.item);
  }

  get treeItems() {
    const orphans: DesignSetPost[] = [];

    const groupedByTags = this.filteredItems.reduce((r, a) => {
      if (!a.tags.length) {
        orphans.push(a);
      } else {
        a.tags.forEach(tag => {
          r[tag] = r[tag] || [];
          r[tag].push(a);
        });
      }

      return r;
    }, Object.create(null));

    const tags = Object.keys(groupedByTags).map(key => {
      return {
        id: key,
        name: key,
        children: groupedByTags[key]
      };
    });

    return [...orphans, ...tags];
  }
}
